export { default } from './NewSizeGuide';
